module.exports = __webpack_public_path__ + "static/user-thumbnail-1-149c3522a6e6a952c91c9dc03612136e.png";